import { createFileRoute } from '@tanstack/react-router';
import { UserFrame } from '@/app/shell/me-layout';
import { InvitationsPage } from '@/features/spaces/pages/invitations-page';

/**
 * The invitations to spaces waiting for the person (/invitations/spaces): the page the invitation
 * e-mails link to. Any signed-in user; a guest sees it in the restricted shell.
 */
export const Route = createFileRoute('/_auth/invitations/spaces')({
  component: InvitationsRoute,
});

function InvitationsRoute() {
  return (
    <UserFrame>
      <InvitationsPage />
    </UserFrame>
  );
}
